interface BlueyonderUserDto {
  user_code: string;
  user_name: string;
  language_code: string;
  logistics_group_code: string;
  country_code: string;
}

export class BlueyonderUser {
  userCode: string;
  userName: string;
  userGroup: string;
  languageCode: string;
  countryCode: string;

  static fromDto(c: BlueyonderUserDto): BlueyonderUser {
    if (!c) {
      return null;
    }

    const blueyonderUser = new BlueyonderUser();

    blueyonderUser.userCode     = c.user_code;
    blueyonderUser.userName     = c.user_name;
    blueyonderUser.userGroup    = c.logistics_group_code;
    blueyonderUser.languageCode = c.language_code;
    blueyonderUser.countryCode  = c.country_code;

    return blueyonderUser;
  }

  toDto(): BlueyonderUserDto {
    return {
      user_code: this.userCode,
      user_name: this.userName,
      language_code: this.languageCode,
      logistics_group_code: this.userGroup,
      country_code: this.countryCode,
    };
  }
}
